import Foot from "../../components/footer/Foot";
import "./footer.css";

const Footer = () => (
  <section className="footer">
    <div className="box-container">
      <Foot />
    </div>
  </section>
);

export default Footer;
